var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "leaflet-map leaflet-map--map c-ai-route-map" },
    [
      _c("div", { ref: "map", staticClass: "c-ai-route-map__canvas" }),
      _vm._v(" "),
      _vm.stops.length === 0 && !_vm.start
        ? _c("div", { staticClass: "leaflet-map--map__message" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.emptyText ||
                    _vm.$t("weeks.projectplanningexport.map.no_stops")
                )
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.routeError
        ? _c("div", { staticClass: "c-ai-route-map__warning" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("weeks.projectplanningexport.map.route_error")) +
                "\n  "
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }